import * as React from 'react';
import {
    Project,
} from "../../../../../domain/model/project";
import {Company} from "../../../../../domain/model/company";
import ProjectView from "../../../../common/template/page_project/project_veiw";

interface IProps {
    project: Project | null;
    company: Company | null;
}

export const ClientProjectMainPreview: React.FC<IProps> = (props) => {
    const {project, company} = props;

    if (!project || !company) { return (<div>データがありません</div>) }

    return (
        <React.Fragment>
            <ProjectView project={project} company={company}/>
        </React.Fragment>
    )

};

export default ClientProjectMainPreview;


// WEBPACK FOOTER //
// ./src/presentation/component/client/project/preview/client_project_main_preview.tsx